// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#outing-edit[data-v-71025689]{max-width:840px;margin-left:auto;margin-right:auto}#outing-edit .cancel-btn[data-v-71025689],#outing-edit .edit-btn[data-v-71025689]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
